import { Box, Container, Typography, Card, CardContent, CardMedia, IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';

const teamMembers = [
  {
    name: 'Sarah Johnson',
    role: 'CEO & Founder',
    image: 'https://randomuser.me/api/portraits/women/1.jpg',
    description: 'Blockchain veteran with 10+ years in crypto. Previously led major DeFi projects.',
    linkedin: 'https://linkedin.com',
    twitter: 'https://twitter.com',
    github: 'https://github.com'
  },
  {
    name: 'Michael Chen',
    role: 'CTO',
    image: 'https://randomuser.me/api/portraits/men/2.jpg',
    description: 'Smart contract expert. Built multiple successful DEX platforms.',
    linkedin: 'https://linkedin.com',
    twitter: 'https://twitter.com',
    github: 'https://github.com'
  },
  {
    name: 'Emma Wilson',
    role: 'Lead Developer',
    image: 'https://randomuser.me/api/portraits/women/3.jpg',
    description: 'Full-stack blockchain developer. Solidity & React expert.',
    linkedin: 'https://linkedin.com',
    twitter: 'https://twitter.com',
    github: 'https://github.com'
  },
  {
    name: 'James Rodriguez',
    role: 'Marketing Director',
    image: 'https://randomuser.me/api/portraits/men/4.jpg',
    description: 'Growth hacker with expertise in crypto community building.',
    linkedin: 'https://linkedin.com',
    twitter: 'https://twitter.com',
    github: 'https://github.com'
  },
  {
    name: 'Lisa Zhang',
    role: 'UX Designer',
    image: 'https://randomuser.me/api/portraits/women/5.jpg',
    description: 'Award-winning designer focused on crypto trading interfaces.',
    linkedin: 'https://linkedin.com',
    twitter: 'https://twitter.com',
    github: 'https://github.com'
  },
  {
    name: 'David Kim',
    role: 'Security Lead',
    image: 'https://randomuser.me/api/portraits/men/6.jpg',
    description: 'Cybersecurity expert specializing in DeFi protocol security.',
    linkedin: 'https://linkedin.com',
    twitter: 'https://twitter.com',
    github: 'https://github.com'
  },
  {
    name: 'Alex Thompson',
    role: 'Community Manager',
    image: 'https://randomuser.me/api/portraits/men/7.jpg',
    description: 'Experienced in building and managing crypto communities.',
    linkedin: 'https://linkedin.com',
    twitter: 'https://twitter.com',
    github: 'https://github.com'
  }
];

const Team = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, md: 8 },
        bgcolor: '#1a237e',
        color: 'white',
        minHeight: '100vh'
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              mb: 6,
              textAlign: 'center',
              fontSize: { xs: '2rem', md: '3rem' },
              fontWeight: 'bold'
            }}
          >
            Meet Our Team
          </Typography>

          <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' } }}>
            {teamMembers.map((member, index) => (
              <Box key={member.name}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                >
                  <Card
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      bgcolor: 'rgba(255, 255, 255, 0.05)',
                      backdropFilter: 'blur(10px)',
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'translateY(-8px)'
                      }
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="300"
                      image={member.image}
                      alt={member.name}
                      sx={{
                        objectFit: 'cover',
                        borderBottom: '2px solid rgba(255, 255, 255, 0.1)'
                      }}
                    />
                    <CardContent sx={{ flexGrow: 1, color: 'white' }}>
                      <Typography gutterBottom variant="h5" component="h3">
                        {member.name}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        sx={{ color: '#ff4081', mb: 2 }}
                      >
                        {member.role}
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 2 }}>
                        {member.description}
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton
                          size="small"
                          href={member.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ color: 'white' }}
                        >
                          <LinkedInIcon />
                        </IconButton>
                        <IconButton
                          size="small"
                          href={member.twitter}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ color: 'white' }}
                        >
                          <TwitterIcon />
                        </IconButton>
                        <IconButton
                          size="small"
                          href={member.github}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ color: 'white' }}
                        >
                          <GitHubIcon />
                        </IconButton>
                      </Box>
                    </CardContent>
                  </Card>
                </motion.div>
              </Box>
            ))}
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Team;
